
<div class="container-fluid mt-md-3">

<div class="row">

      <div class="col-sm-12">
        <ul class="nav nav-tabs" style="margin-top: 10px;">
          <li class="nav-item"><a (click)="clearLogs();getLogs();"
            class="nav-link active" style="cursor: pointer;background-color: gainsboro; margin-bottom: 20px;margin-top: 5px;">Refresh</a></li>
          <hr>
        </ul>
        <div style="position: absolute;right: 20px;top: 10px">
          <mat-icon aria-hidden="false" class="fa-2x"
                          style="width: 100%; color: grey;cursor: pointer;"
                          id="closeBtn" (click)="onClick()">
                          close
        </mat-icon>
        </div>

      </div>
      <div class="col-sm-12 text-center">
      <div>
        <mat-form-field class="col-sm-12">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
        </mat-form-field>
      </div>

      <table mat-table [dataSource]="logsTableData" class="col-sm-12 mat-elevation-z8"
        style="background-color: whitesmoke;table-layout: fixed;" matSort>

        <ng-container matColumnDef="job_id">
          <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job ID </th>
          <td mat-cell *matCellDef="let element" class="px-2" [style.background-color]="colorRow(element)"> {{element.job_id?element.job_id:"NA"}} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="job_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Name </th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.job_name?element.job_name:"NA"}} </td>
        </ng-container> -->
        <ng-container matColumnDef="log_time">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Log Time </th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.log_time?element.log_time:"NA"}} </td>
        </ng-container>
        <ng-container matColumnDef="log_content">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Log Content </th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.log_content?element.log_content:"NA"}} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Creation Date</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.created_at?element.created_at:"NA"}} </td>
        </ng-container>

        <ng-container matColumnDef="operation_title">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Operation Title </th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.operation_title?element.operation_title:"NA"}} </td>
        </ng-container>

        <ng-container matColumnDef="operation_request">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Operation Request </th>
          <td mat-cell *matCellDef="let element" style="word-wrap: break-word" [style.background-color]="colorRow(element)"> {{element.operation_request?element.operation_request:"NA"}} </td>
        </ng-container>

        <ng-container matColumnDef="operation_response">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Operation Response </th>
          <td mat-cell *matCellDef="let element" style="word-wrap: break-word" [style.background-color]="colorRow(element)"> {{element.operation_response?element.operation_response:"NA"}}  </td>
        </ng-container>

        <ng-container matColumnDef="parent_job_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Parent job ID</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.parent_job_id?element.parent_job_id:"NA"}} </td>
        </ng-container>

        <ng-container matColumnDef="ip_address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> IP Address</th>
          <td mat-cell *matCellDef="let element" [style.background-color]="colorRow(element)"> {{element.ip_address?element.ip_address:"NA"}} </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [length]='logs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons>
      </mat-paginator>

    </div>
  </div>
</div>
